export const SITE_URL: string = 'https://oopbuyspreadsheet.cam';